import { all } from 'redux-saga/effects'

import authenticationSagas from './authentication/saga'
import commonSagas from './common/saga'
import clientsSagas from './clients/saga'
import teamSagas from './team/saga'
import profileSagas from './profile/saga'
import taskManagerSagas from './taskManager/saga'
import storeSagas from './store/saga'

export default function* startForman(): Generator {
  yield all([
    ...authenticationSagas,
    ...commonSagas,
    ...clientsSagas,
    ...teamSagas,
    ...profileSagas,
    ...taskManagerSagas,
    ...storeSagas,
  ])
}
